<script setup lang="ts">
  import {
    mpfWarningCalloutDefaults,
    type MpfWarningCalloutProps,
  } from './MpfWarningCallout.props';

  const props = withDefaults(defineProps<MpfWarningCalloutProps>(), mpfWarningCalloutDefaults);
</script>

<template>
  <div class="mpf-warning-callout" :class="marginClass">
    <component :is="`h${props.headingLevel}`" class="mpf-warning-callout__label">
      <span v-if="srPrefix" role="text"
        ><span class="mpf-u-visually-hidden">{{ srPrefix }}:</span> {{ heading }}</span
      >
      <template v-else>{{ heading }}</template>
    </component>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  @use './MpfWarningCallout.scss';
</style>
